<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    dark
    floating
    persistent
    mobile-break-point="991"
    width="260"
  >
    <v-img :src="image" height="100%">
      <v-layout class="fill-height" tag="v-list" column>
        <v-list-tile avatar>
          <v-list-tile-avatar color="white">
            <v-img :src="logo" height="54" contain />
          </v-list-tile-avatar>
          <v-list-tile-title class="title">
            innvisiBotFramework
          </v-list-tile-title>
        </v-list-tile>
        <v-divider />
        <v-list-tile v-if="responsive">
          <v-text-field
            class="purple-input search-input"
            label="Search..."
            color="purple"
          />
        </v-list-tile>
        <v-list-tile
          v-for="(link, i) in links"
          :key="i"
          :to="link.to"
          :active-class="color"
          :disabled="link.disabled"
          avatar
          class="v-list-item"
        >
          <v-list-tile-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title v-text="$t('home.' + link.text)" />
        </v-list-tile>
      </v-layout>
    </v-img>
    <v-footer id="core-footer" absolute height="82">
      <v-layout justify-center>
        <v-flex md12>
          <v-img :src="innlogo" height="60" contain />
        </v-flex>
      </v-layout>
    </v-footer>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapMutations, mapState } from "vuex";

export default {
  data: () => ({
    logo: require("@/assets/img/bot_48x48_inverted.png"),
    innlogo: require("@/assets/img/logo_300x100_transparent.png"),
    links: [
      {
        to: "/",
        icon: "mdi-view-dashboard",
        text: "features",
        disabled: false
      },
      {
        to: "/adminbot",
        icon: "mdi-account",
        text: "adminbot",
        disabled: false
      },
      {
        to: "/nlp-analyzer",
        icon: "mdi-chart-bubble",
        text: "nlpanalyzer",
        disabled: true
      },
      {
        to: "/nlp-tester",
        icon: "mdi-chart-bubble",
        text: "nlptester",
        disabled: false
      }
      /**
      ,
      {
        to: "/dashboard/table-list",
        icon: "mdi-clipboard-outline",
        text: "Table List"
      },
      {
        to: "/dashboard/user-tables",
        icon: "mdi-table-edit",
        text: "Users Table"
      },
      {
        to: "/dashboard/typography",
        icon: "mdi-format-font",
        text: "Typography"
      },
      {
        to: "/dashboard/icons",
        icon: "mdi-chart-bubble",
        text: "Icons"
      },
      {
        to: "/dashboard/maps",
        icon: "mdi-map-marker",
        text: "Maps"
      },
      {
        to: "/dashboard/notifications",
        icon: "mdi-bell",
        text: "Notifications"
      }
      **/
    ],
    responsive: false
  }),
  computed: {
    ...mapState("app", ["image", "color"]),
    inputValue: {
      get() {
        return this.$store.state.app.drawer;
      },
      set(val) {
        this.setDrawer(val);
      }
    },
    items() {
      return this.$t("Layout.View.items");
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    }
  }
};
</script>

<style lang="scss">
#app-drawer {
  .v-list__tile {
    border-radius: 4px;

    &--buy {
      margin-top: auto;
      margin-bottom: 17px;
    }
  }

  .v-image__image--contain {
    top: 9px;
    height: 60%;
  }

  .search-input {
    margin-bottom: 30px !important;
    padding-left: 15px;
    padding-right: 15px;
  }
}
</style>
